import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

const SelectInput = ({
	id,
	labelSelect,
	label,
	control,
	data,
	errors,
	handleSelect = () => {},
	onKeyDown = () => {},
	loading,
	className = "",
	autoFocus = false,
}) => {
	const [formattedOptions, setFormattedOptions] = useState([]);

	useEffect(() => {
		if (data) {
			const newformattedOptions = data.map((option) => ({
				value: option[id], //o que quer q retorna ex.: id_cidade
				label: option[labelSelect], //o que quer q apareça ex.: nome
			}));

			setFormattedOptions(newformattedOptions);
		}
	}, [data]);

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			const focusedOption = document.querySelector(".react-select__option--is-focused"); // Identifica o item focado usando a classe react-select__option--is-focused

			if (focusedOption) {
			} else {
				event.preventDefault();
				onKeyDown(event);
			}
		}
	};

	const handleOnChange = (selectedOption, onChange, value) => {
		const oldValue = value;
		const newValue = selectedOption.value;

		if (oldValue === newValue) return; // Evita que o valor seja atualizado sem necess

		onChange(newValue); // Atualiza o valor

		handleSelect(selectedOption);
	};

	const handleValue = (formattedOptions, value) => {
		// ficar atento com o valor se esta comparando inteiro com string
		const selectedOption = formattedOptions.find((option) => option.value === value) || null;
		return selectedOption;
	};

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			borderColor: state.isFocused ? "#333" : "#aaa",
			boxShadow: state.isFocused ? "0 0 0 1px #e6e6e6" : "none",
			height: "42px", // Set the height to 42px
			"&:hover": {
				borderColor: "#cfcece",
			},
		}),
	};

	return (
		<div className={`input-select-box d-flex flex-column mb-2 ${className}`}>
			<label htmlFor={id}>{label}</label>
			<Controller
				name={id}
				control={control}
				render={({ field: { onChange, value } }) => (
					<Select
						className="select"
						id={id}
						options={formattedOptions}
						value={handleValue(formattedOptions, value)} // Pass value to handleValue
						onChange={(selectedOption) => handleOnChange(selectedOption, onChange, value)}
						onKeyDown={handleKeyDown}
						classNamePrefix="react-select"
						styles={customStyles}
						isLoading={loading}
						autoFocus={autoFocus}
					/>
				)}
			/>
			{errors?.[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default SelectInput;
